import React from "react"

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


import { isNull, isEqual, isArray } from "lodash";

import {hasProperty, formatText, formatDate} from '../utils/utils';
import {cloneObject, getParam, truncate} from '../utils/utils';

import D3Graphviz from "../components/D3Graphviz";

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewInterface from "../components/ViewInterface";
import ViewParameter from "../components/ViewParameter";
import ViewMethod from "../components/ViewMethod";

import ViewSerialization from "../components/ViewSerialization";
import Buffering from "../components/Buffering";

import { getInterfaceVersion, getInterfaceVersionSerializations, zipInterface } from "../utils/utilsInterface";


class ViewInterfaceVersion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };


        this.handleControls = this.handleControls.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleExport = this.handleExport.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

        this.setup();
 
     }

     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props.params, prevProps.params)){
            this.setup();
        }

     }



    setup(){

        let StateChange = {
            idVersion: null,
            idInterface: null,
            type: null,
            Interface: null,
            isLoaded: false,
            isFailed: false, 

            Controls: {
            },

            dotSerializations: null

        }

        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idInterface = getParam('idInterface', this.props);

        StateChange.isExporting = false;
        this.setState(StateChange);

        this.loadData(StateChange.idInterface, StateChange.idVersion);


    }

    loadData(id, idVersion){

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Interface = data;
            StateChange.isLoaded = true;
            this.setState(StateChange);
            return;
        }.bind(this);

        var onFail = function(e){
            let StateChange = {};
            StateChange.Interface = null;
            StateChange.isFailed = true;

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);


        if (id){
            getInterfaceVersion(this.dsd, id, idVersion, onLoad, onFail);
        }


        const onLoadSerializationsDot = (dots) => {
            this.setState({dotSerializations: dots});
        };

        const onFailSerializationsDot = (e) => {
            console.error('Error fetching DOT:', e);
        };

        getInterfaceVersionSerializations(
            this.dsd,
            id,
            idVersion,
            onLoadSerializationsDot,
            onFailSerializationsDot,
            'dot',
            null,
            {}
        );

        return;
    }

    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});

        return;

    }


    handleNavClick(event) {

        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }

        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }

        }

        event.preventDefault();

    };


    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let Interface = cloneObject(this.state.Interface); 
            let Version = Interface.Version;
            let idInterface = this.state.idInterface;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipInterface(this.dsd, Interface);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `interface_${idInterface}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }

    }

    render() {

        if (this.state.isFailed){
            return <PD.ErrorBox>{this.state.errorMessage}</PD.ErrorBox>
        }

        if (this.state.isLoaded){
            return(
                <div>
                    <PD.Heading>{`Interface: ${this.state.Interface.name}`}</PD.Heading>
                    {this.state.Interface.Version &&
                        <>
                           {this.viewVersion(this.state.Interface.Version)}
                        </>
                    }
                    {this.viewInterface(this.state.Interface)}
                </div>
            )
        }
        return null;

    };    

    viewVersion(Version){

        if (Version){
            return(
                <fieldset>
                    <legend>Named Version</legend>
                    <PD.Table className="panel">
                        <PD.Tbody>                                

                            {hasProperty(Version,'name') &&
                                <PD.Tr>                                
                                    <PD.Th>Name</PD.Th><PD.Td>{Version.name}</PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'description') &&
                                <PD.Tr>
                                    <PD.Th>Description</PD.Th>
                                    <PD.Td>
                                        <PD.MdPresent>
                                            {Version.description}
                                        </PD.MdPresent>                                    
                                    </PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'createdAt') &&
                                <PD.Tr>
                                    <PD.Th>Date/Time</PD.Th><PD.Td>{formatDate(Version.createdAt,'dmy hms')}</PD.Td>
                                </PD.Tr>
                            }

                        </PD.Tbody>
                    </PD.Table>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                </fieldset>
                
            )
        };
        return null;
    };

    viewInterface(Interface){
        if (Interface){

            let countParameters = 0;
            if (Interface.Parameters){
                if (Interface.Parameters.length){
                    countParameters = Interface.Parameters.length;
                }
            }

            let countMethods = 0;
            if (Interface.Methods){
                if (Interface.Methods.length){
                    countMethods = Interface.Methods.length;
                }
            }

            let countSerializations = 0;
            let DataSpecSerializations = {}
            for (let posM=0; posM<Interface.Methods.length; posM++){
                const Method = Interface.Methods[posM];
                for (let posR=0; posR<Method.Responses.length; posR++){
                    const Response = Method.Responses[posR];
                    if (Response.Serialization){
                        const Serialization = Response.Serialization;
                        const DataSpec = Serialization.DataSpec;
                        if (DataSpec){
                            if (!(DataSpec._id in DataSpecSerializations)){
                                DataSpecSerializations[DataSpec._id] = {
                                    'name':DataSpec.name,
                                    'Serializations':{}
                                }
                            }
                            DataSpecSerializations[DataSpec._id].Serializations[Serialization._id] = {}
                        }
                    }
                }
            }
            for (let idDataSpec in DataSpecSerializations){
                const DataSpecSerialization = DataSpecSerializations[idDataSpec];
                if (Interface.DataSpecs){
                    for (let posD=0; posD<Interface.DataSpecs.length;posD++){
                        const InterfaceDataSpec = Interface.DataSpecs[posD];
                        if (InterfaceDataSpec.DataSpec){
                            const DataSpec = InterfaceDataSpec.DataSpec;
                            if (DataSpec._id == idDataSpec){
                                DataSpecSerialization.DataSpec = DataSpec;
                                for (let idSerialization in DataSpecSerialization.Serializations){
                                    countSerializations++;
                                    for (let posS=0; posS<DataSpec.Serializations.length;posS++){
                                        const Serialization = DataSpec.Serializations[posS];
                                        if (Serialization._id == idSerialization){
                                            DataSpecSerialization.Serializations[idSerialization] = Serialization;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return(
                <div>
                    <ViewInterface Interface={Interface} noLinks/>

                    <PD.Heading level="2">Index</PD.Heading>

                    {countParameters &&
                        <fieldset>
                            <legend>Parameters</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        Interface.Parameters.map(
                                            (Parameter, pos) => 
                                            {                
                                                switch (Parameter.status){
                                                    case 'deprecated': return null;
                                                    default:

                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#parameter_${Parameter._id}`} onClick={this.handleNavClick}>{Parameter.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Parameter.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>
                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    {countMethods &&
                        <fieldset>
                            <legend>Methods</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        Interface.Methods.map(
                                            (Method, pos) => 
                                            {                
                                                switch (Method.status){
                                                    case 'deprecated': return null;
                                                    default:

                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#method_${Method._id}`} onClick={this.handleNavClick}>{Method.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Method.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>
                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    {countSerializations &&
                        <fieldset>
                            <legend>Serializations</legend>
                            {
                                Object.keys(DataSpecSerializations).map(
                                    (idDataSpec, posD) => 
                                    {
                                        const DataSpecSerialization = DataSpecSerializations[idDataSpec];
                                        return(
                                            <div key={posD}>
                                                <strong>{DataSpecSerialization.name}</strong>

                                                <PD.Table className="list">
                                                    <PD.Thead>
                                                        <PD.Tr>
                                                            <PD.Th>Name</PD.Th>
                                                            <PD.Th>Description</PD.Th>
                                                        </PD.Tr>
                                                    </PD.Thead>
                                                    <PD.Tbody>
                                                        {
                                                            Object.keys(DataSpecSerialization.Serializations).map(
                                                                (idSerialization, posS) => 
                                                                {                
                                                                    const Serialization = DataSpecSerialization.Serializations[idSerialization]                    
                                                                    return (
            
                                                                        <PD.Tr key={posS}>
                                                                            <PD.Td>
                                                                                <PD.PdNavLink to={`#serialization_${Serialization._id}`} onClick={this.handleNavClick}>{Serialization.name}</PD.PdNavLink>
                                                                            </PD.Td>
                                                                            <PD.Td>
                                                                                <PD.MdPresent>{truncate(Serialization.description, 400)}</PD.MdPresent>
                                                                            </PD.Td>
                                                                        </PD.Tr>
                                                                    )
                                                                }
                                                        
                                                            )
                                                        }
                                                    </PD.Tbody>
                                                </PD.Table>
                                            </div>


                                        )
                                    }        
                                )
                            }
                        </fieldset>
                    }


                    <fieldset>
                        <legend>Renditions</legend>
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Type</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>
                            <PD.Tbody>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_oad`} onClick={this.handleNavClick}>Open API Document</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>

                            </PD.Tbody>
                        </PD.Table>
                    </fieldset>

                    {
                        countParameters &&
                            <div>
                                <PD.Heading level="2">Parameters</PD.Heading>
                                {
                                    Interface.Parameters.map(
                                        (Parameter, pos) =>    
                                        {
                                            
                                            switch (Parameter.status){
                                                case 'deprecated': return null;
                                                default:

                                                    return (
                                                        <fieldset key={pos} id={`parameter_${Parameter._id}`}>
                                                            <ViewParameter Parameter={Parameter} noLinks/>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }


                    {
                       
                        countMethods &&
                            <div>
                                <PD.Heading level="2">Methods</PD.Heading>
                                {
                                    Interface.Methods.map(
                                        (Method, pos) =>    
                                        {
                                            
                                            switch (Method.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset key={pos} id={`method_${Method._id}`}>
                                                            <ViewMethod Method={Method} noLinks/>
                                                            {this.viewMethodParameters(Method)}
                                                            {this.viewMethodResponses(Method)}
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                            
                    }


                    {countSerializations &&
                        <div>
                            <PD.Heading level="2">Serializations</PD.Heading>
                            {
                                Object.keys(DataSpecSerializations).map(
                                    (idDataSpec, posD) => 
                                    {
                                        const DataSpecSerialization = DataSpecSerializations[idDataSpec];
                                        return(
                                            <div key={posD}>
                                                {
                                                    Object.keys(DataSpecSerialization.Serializations).map(
                                                        (idSerialization, posS) => 
                                                        {
                                                            const Serialization = DataSpecSerialization.Serializations[idSerialization];
                                                            
                                                            return(
                                                                <fieldset key={posS} id={`serialization_${Serialization._id}`}>
                                                                    <ViewSerialization Serialization={Serialization} noLinks/>
                                                                    <fieldset>
                                                                        <legend>visualisation</legend>
                                                                        <D3Graphviz dot={this.state.dotSerializations && this.state.dotSerializations[Serialization._id]} onClick={this.handleNavClick}/>
                                                                    </fieldset>
                                                                </fieldset>
                                                            )
                                                        }
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                )
                            }
                        </div>
                    }

                    <div>
                        <PD.Heading level="2">Renditions</PD.Heading>
                        <fieldset id="rendition_oad">
                            <legend>Open API Document</legend>
                            <pre>
                                <ViewInterfaceOAD dsd={this.dsd} idInterface={Interface._id} idVersion={this.state.idVersion}/>                                                                
                            </pre>
                        </fieldset>
                    </div>
                    

                </div>
            )
        }
    }

    viewMethodParameters(Method){
        if (!Method.Parameters){
            return
        }
        if (!Method.Parameters.length){
            return
        }
        return(
            <fieldset>
                <legend>Parameters</legend>
                <PD.Table className="list">
                    <PD.Thead>
                        <PD.Tr>
                            <PD.Th>Name</PD.Th>
                            <PD.Th>Description</PD.Th>
                            <PD.Th>Where?</PD.Th>
                            <PD.Th>Occurs</PD.Th>
                            <PD.Th>Required?</PD.Th>
                        </PD.Tr>
                    </PD.Thead>
                    <PD.Tbody>
                        {
                            Method.Parameters.map(
                                (MethodParameter, pos) => 
                                {                
                                    let Parameter = {}
                                    if (MethodParameter.Parameter){
                                        Parameter = MethodParameter.Parameter;
                                    }
                                    return (

                                        <PD.Tr key={pos}>
                                            <PD.Td>
                                                <PD.PdNavLink to={`#parameter_${Parameter._id}`} onClick={this.handleNavClick}>{Parameter.name}</PD.PdNavLink>
                                            </PD.Td>
                                            <PD.Td>
                                                <PD.MdPresent>{truncate(Parameter.description, 400)}</PD.MdPresent>
                                            </PD.Td>
                                            <PD.Td>{MethodParameter.where}</PD.Td>
                                            <PD.Td>{MethodParameter.occurs}</PD.Td>
                                            <PD.Td>{MethodParameter.required}</PD.Td>

                                        </PD.Tr>
                                    )
                                }
                        
                            )
                        }
                    </PD.Tbody>
                </PD.Table>
            </fieldset>
        )


    }


    viewMethodResponses(Method){
        if (!Method.Responses){
            return
        }
        if (!Method.Responses.length){
            return
        }
        return(
            <fieldset>
                <legend>Responses</legend>
                <PD.Table className="list">
                    <PD.Thead>
                        <PD.Tr>
                            <PD.Th>Status Code</PD.Th>
                            <PD.Th>Status Description</PD.Th>
                            <PD.Th>Serialization</PD.Th>                            
                            <PD.Th>Occurs</PD.Th>
                        </PD.Tr>
                    </PD.Thead>
                    <PD.Tbody>
                        {
                            Method.Responses.map(
                                (Response, pos) => 
                                {                
                                    return (

                                        <PD.Tr key={pos}>
                                            <PD.Td>
                                                {Response.statusCode}
                                            </PD.Td>
                                            <PD.Td>
                                                <PD.MdPresent>{truncate(Response.description, 400)}</PD.MdPresent>
                                            </PD.Td>
                                            <PD.Td>
                                                {Response.Serialization &&
                                                    <PD.PdNavLink to={`#serialization_${Response.Serialization._id}`} onClick={this.handleNavClick}>{Response.Serialization.name}</PD.PdNavLink>
                                                }
                                            </PD.Td>
                                            <PD.Td>
                                                {Response.occurs}
                                            </PD.Td>

                                        </PD.Tr>
                                    )
                                }
                        
                            )
                        }
                    </PD.Tbody>
                </PD.Table>
            </fieldset>
        )


    }
 
};



class ViewInterfaceOAD extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };
    }

    componentDidMount(){
        this.setup(); 
    }

    setup(){

        let StateChange = {
            idVersion: null,
            idInterface: null,
            isLoaded: false,
            isFailed: false, 
            OAD: null
        }

        const dsd = getParam('dsd', this.props);
        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idInterface = getParam('idInterface', this.props);
        if (StateChange.idInterface){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.OAD = data;
                StateChange.isLoaded = true;
                this.setState(StateChange);
                return;
            }.bind(this);
    
            var onFail = function(e){
                let StateChange = {};
                StateChange.OAD = null;
                StateChange.isFailed = true;
    
                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            getInterfaceVersion(dsd,StateChange.idInterface,StateChange.idVersion, onLoad, onFail,'oad')
        }

        this.setState(StateChange);

    }

    render(){
        if (this.state.isLoaded){
            return(
                JSON.stringify(this.state.OAD, null, "\t")
            )
        }
        return <div/>
    }

};



        
export default function ViewInterfaceVersion_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ViewInterfaceVersion {...props} navigation={navigation} location={location} params={params} />;
  }
